module.exports = __webpack_public_path__ + "static/img/img_cabinet.8d73c4a4.png";